import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { ErrorPopupComponent } from '../../sharedcomponents/_directive/error-popup/error-popup.component';

import { TranslateService } from 'ng2-translate/ng2-translate';

@Injectable()
export class AlertService {
  private subject = new Subject<any>();
  private keepAfterNavigationChange = false;

  constructor(private router: Router, private modal: Modal, private translate: TranslateService) {
    // clear alert message on route change
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterNavigationChange) {
          // only keep for a single location change
          this.keepAfterNavigationChange = false;
        } else {
          // clear alert
          this.subject.next();
        }
      }
    });
  }

  success(message: string, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ type: 'success', text: message });
  }

  error(message: string, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ type: 'error', text: message });
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

  OpenModal(title, header, message) {
    this.modal
      .alert()
      .size('sm')
      .showClose(true)
      .title(title)
      .body(
        `<div class="custom-modal-container">
            <div class="modal-header"><h4>` +
          header +
          `</h4></div>
            <p>
                <div class="modal-body bg-danger">` +
          message +
          `</div>
            </p>
            </div>
            `
      )
      .open();
  }
  OpenInfoModal(title, header, message) {
    return (
      this.modal
        .confirm()
        .size('sm')
        // .showClose(true)
        // .title(title)
        .body(
          `<div class="custom-modal-container">
            <div class="modal-header"><h4>` +
            header +
            `</h4></div>
            <p>
                <div class="modal-body bg-danger">` +
            message +
            `</div>
            </p>
              <div class="modal-footer"><buttun>OK</buttun><buttun>Cancel</buttun></div>
            </div>
            `
        )
        .open()
    );
  }

  openErrorAlert(title, msg) {
    const modalData: any = {};
    modalData.Title = title;
    modalData.Message = msg;
    // this.modal.overlay.defaultViewContainer = this.vcRef;
    this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/commonservice/alert.service.ts